var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomSceneryCabinet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 101,
    viewBox: "0 0 57 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M0 0h57v8H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M.5.5h56v7H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M0 7h57v94H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M.5 7.5h56v93H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M7 14h42v75H7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M7.5 14.5h41v74h-41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M12 19h32v65H12z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M12.5 19.5h31v64h-31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryCabinet);
export default __webpack_public_path__ + "static/media/RoomSceneryCabinet.adc49146c663a5d411b94b037f47e603.svg";
export { ForwardRef as ReactComponent };